import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, shareReplay, tap } from 'rxjs/operators';
import { Api } from '../../contracts/classes/api.class';
import { TenantLocalService } from './tenantlocal.service';

@Injectable({ providedIn: 'root' })
export class ClassificationService extends Api {

    private tenantLocal = inject(TenantLocalService);
    private cache$: Observable<any> | null = null;
    private cacheTenant: string | null = null;

    getAll() {
        return this.http.get(`${this.url}/plataformaClasificacions`).pipe(
            map((response: any) => response)
        );
    }

    /**
     * Igual que getAll(), pero la respuesta se guarda en memoria por tenant.
     * Se invalida al crear, editar o eliminar clasificaciones.
     */
    getAllCached(): Observable<any> {
        const tenant = this.tenantLocal.tenantSlug;
        if (!this.cache$ || this.cacheTenant !== tenant) {
            this.cacheTenant = tenant;
            this.cache$ = this.getAll().pipe(
                catchError(error => {
                    this.clearCache();
                    return throwError(() => error);
                }),
                shareReplay(1)
            );
        }
        return this.cache$;
    }

    clearCache(): void {
        this.cache$ = null;
    }

    create(data: any) {
        return this.http.post(`${this.url}/plataformaClasificacions`, data).pipe(tap(() => this.clearCache()));
    }

    update(data: any) {
        return this.http.put(`${this.url}/plataformaClasificacions/${data.id}`, data).pipe(tap(() => this.clearCache()));
    }

    delete(id: number) {
        return this.http.delete(`${this.url}/plataformaClasificacions/${id}`).pipe(tap(() => this.clearCache()));
    }
}
